import { render } from "./amlakRegion.vue?vue&type=template&id=43000c12&scoped=true"
import script from "./amlakRegion.vue?vue&type=script&lang=js"
export * from "./amlakRegion.vue?vue&type=script&lang=js"

import "./amlakRegion.vue?vue&type=style&index=0&id=43000c12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43000c12"]])

export default __exports__